export default {
  state: {
    users: [],
    user: null,
  },
  getters: {
    userPermissions: state => state.user?.permissions || [],
    user: state => state.user,
  },
  actions: {

  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    setUser(state, userData) {
      state.user = userData;
    },
    // ...
  },
  // ...
};
